import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from '../modules/auth/LoginPage'
import TestLoginPage from '../modules/auth/TestLoginPage'
import AdminLayout from '../modules/layout/AdminLayout'
import ProtectedRoute from '../components/ProtectedRoute'
import UsersPage from '../modules/users/UsersPage'
import MessageHistoryPage from '../modules/messages/MessageHistoryPage'
import ProductsPage from '../modules/products/ProductsPage'
import TestProductsPage from '../modules/products/TestProductsPage'
import OrdersPage from '../modules/orders/OrdersPage'
import SettingsPage from '../modules/settings/SettingsPage'
import ReportsPage from '../modules/reports/ReportsPage'
import BootstrapPage from '../modules/bootstrap/BootstrapPage'
import CouponsPage from '../modules/coupons/CouponsPage'
import WalletsPage from '../modules/wallets/WalletsPage'
import PaymentsPage from '../modules/payments/PaymentsPage'
import FinancialTransactionsPage from '../modules/payments/FinancialTransactionsPage'
import SearchPage from '../modules/search/SearchPage'
import SellerAnalyticsPage from '../modules/analytics/SellerAnalyticsPage'
import ComplaintsPage from '../modules/complaints/ComplaintsPage'
import AbuseReportsPage from '../modules/reports-abuse/AbuseReportsPage'
import StoreActivationRequestsPage from '../modules/storeActivation/StoreActivationRequestsPage'
import SubscriptionsLayout from '../modules/subscriptions/SubscriptionsLayout'
import MerchantSubscriptionsPage from '../modules/subscriptions/MerchantSubscriptionsPage'
import SubscriptionPaymentsPage from '../modules/subscriptions/SubscriptionPaymentsPage'
import SubscriptionCouponsPage from '../modules/subscriptions/SubscriptionCouponsPage'
import SubscriptionSettingsPage from '../modules/subscriptions/SubscriptionSettingsPage'
import MerchantsMapPage from '../modules/merchantsMap/MerchantsMapPage'
import AppSettingsPage from '../modules/appSettings/AppSettingsPage'
import AuthMethodsPage from '../modules/settings/AuthMethodsPage'
import OtpMonitorPage from '../modules/otpMonitor/OtpMonitorPage'
import AuthPhoneMonitorPage from '../modules/authPhoneMonitor/AuthPhoneMonitorPage'

export default function Router() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/test-login" element={<TestLoginPage />} />
      <Route path="/bootstrap" element={<BootstrapPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/users" replace />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="message-history" element={<MessageHistoryPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="test-products" element={<TestProductsPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="otp-monitor" element={<OtpMonitorPage />} />
        <Route path="auth-phone-monitor" element={<AuthPhoneMonitorPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="wallets" element={<WalletsPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="financial-transactions" element={<FinancialTransactionsPage />} />
        <Route path="seller-analytics" element={<SellerAnalyticsPage />} />
        <Route path="complaints" element={<ComplaintsPage />} />
        <Route path="abuse-reports" element={<AbuseReportsPage />} />
        <Route path="store-activation" element={<StoreActivationRequestsPage />} />
        <Route path="merchants-map" element={<MerchantsMapPage />} />
        <Route path="merchant-subscriptions" element={<SubscriptionsLayout />}>
          <Route index element={<MerchantSubscriptionsPage />} />
          <Route path="payments" element={<SubscriptionPaymentsPage />} />
          <Route path="coupons" element={<SubscriptionCouponsPage />} />
          <Route path="settings" element={<SubscriptionSettingsPage />} />
        </Route>
        <Route path="settings" element={<SettingsPage />} />
        <Route path="auth-methods" element={<AuthMethodsPage />} />
        <Route path="app-settings" element={<AppSettingsPage />} />
        <Route path="reports" element={<ReportsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
